import { gql } from "@outschool/ui-apollo";

import PublicReviewFragment from "./PublicReviewFragment";

export default gql`
  query ActivityRatingAndReviews(
    $uid: ID!
    $offset: Int!
    $limit: Int!
    $skipAggregates: Boolean!
    $summaryVariant: String
  ) {
    activity(uid: $uid) {
      uid
      recentReviews(offset: $offset, limit: $limit) {
        ...PublicReviewFragment
      }
      reviewsWithAttachments {
        ...PublicReviewFragment
      }
      leader {
        uid
        name
        leader_link
        created_at
        photo
        cityState
        details {
          about
          headline
          countryOfResidence
        }
        is_crosslister
        timeZone
        hasAvailabilitySet
        approved
        ownerOfSellerOrg {
          uid
        }
        teacherForSellerOrg {
          uid
          name
        }
        hasBackgroundCheckExpired
      }
      averageStarRating @skip(if: $skipAggregates)
      reviewCount @skip(if: $skipAggregates)
      reviewsWithTextCount @skip(if: $skipAggregates)
      feedbackSummary(variant: $summaryVariant) @skip(if: $skipAggregates) {
        uid
        pros
      }
    }
  }
  ${PublicReviewFragment}
`;
